module.exports = __webpack_public_path__ + "img/contest-logo-bg.1ad0e765.png";